// Em grupos o `contact` de uma mensagem recebida é o próprio grupo, então o
// nome de quem escreveu tem de ser resolvido a partir do participante. Esta
// cadeia é a mesma que o histórico (MessagesList) usa — mantê-la num só lugar
// evita que a busca e o histórico mostrem nomes diferentes para a mesma
// mensagem.

export const getMessageJsonData = (message) => {
  try {
    if (!message?.dataJson) {
      return {};
    }
    return typeof message.dataJson === "string"
      ? JSON.parse(message.dataJson)
      : message.dataJson;
  } catch (error) {
    return {};
  }
};

export const getParticipantNumberFromJid = (participantJid) => {
  const localPart = String(participantJid || "").split("@")[0].split(":")[0].trim();
  return localPart || "";
};

export const isGroupRemoteJid = (remoteJidValue) => {
  return String(remoteJidValue || "").trim().endsWith("@g.us");
};

/**
 * Nome do autor de uma mensagem de grupo, na ordem de preferência do histórico:
 * `participantName` (injetado pelo backend a partir de GroupParticipants) →
 * `pushName`/`notify`/`verifiedBizName` do payload do WhatsApp → número do
 * participante.
 *
 * Resolve apenas a cadeia de nomes: cabe a quem chama decidir se a mensagem
 * está em contexto de grupo e qual o fallback. Devolve "" se nada for
 * encontrado.
 *
 * @param {object} messageLike mensagem (ou quotedMsg)
 * @param {{ onNumberFallback?: (number: string) => void }} [options]
 */
export const resolveGroupSenderName = (messageLike, options = {}) => {
  const { onNumberFallback } = options;

  const backendParticipantName = String(messageLike?.participantName || "").trim();
  if (backendParticipantName) {
    return backendParticipantName;
  }

  const data = getMessageJsonData(messageLike);

  const pushName = String(data?.pushName || "").trim();
  if (pushName) {
    return pushName;
  }

  const notifyName = String(data?.notify || "").trim();
  if (notifyName) {
    return notifyName;
  }

  const verifiedBizName = String(data?.verifiedBizName || "").trim();
  if (verifiedBizName) {
    return verifiedBizName;
  }

  const participantNumber = getParticipantNumberFromJid(messageLike?.participant);
  if (participantNumber) {
    if (typeof onNumberFallback === "function") {
      onNumberFallback(participantNumber);
    }
    return participantNumber;
  }

  return "";
};
